<script>
import Layout from "@layouts/main.layout.vue";
import DatePicker from "@components/DatePicker.vue";
import DocumentDialog from "@components/dialogs/DocumentDialog.vue";
import PrintDialog from "@components/dialogs/PrintAmountDialog.vue";

export default {
    name: "PruefkleberView",
    components: {
        Layout,
        DatePicker,
        DocumentDialog,
        PrintDialog,
    },
    data() {
        return {
            label: {
                // Same shape DatePicker emits (UTC midnight), so today formats like a picked date on the label
                inspect_date: Date.parse(this.$moment().format("YYYY-MM-DD")),
                contract_id: null,
                protection: null,
                schema_id: null,
                rated_voltage: null,
                rated_current: [],
                frequency: null,
                norm: "EN IEC 61439-1:2021/-3",
            },
            presets: {
                protection: ["2XC", "IP2XC", "IP2XB"],
                rated_voltage: ["3x400/230V", "1x230V", "1x48VDC", "1x24VAC", "1x24VDC"],
                frequency: ["50Hz", "-"],
                norm: ["EN IEC 61439-1:2021/-2", "EN IEC 61439-1:2021/-3"],
            },
        };
    },
    methods: {
        preview() {
            this.$refs.document_dialog.open("pruefkleber", this.label);
        },
        print() {
            this.$refs.print_dialog.open("pruefkleber", this.label);
        },
    },
};
</script>

<template>
    <Layout>
        <div class="pruefkleber">
            <div class="pruefkleber-form">
                <div class="layout-title">Prüfkleber</div>
                <v-row dense>
                    <v-col cols="12" sm="6"><DatePicker v-model="label.inspect_date" label="Herstellungsdatum" /></v-col>
                    <v-col cols="12" sm="6"><v-text-field v-model="label.contract_id" label="Auftragsnummer" /></v-col>
                    <v-col cols="12" sm="6"><v-combobox v-model="label.protection" :items="presets.protection" label="Schutzgrad" /></v-col>
                    <v-col cols="12" sm="6"><v-text-field v-model="label.schema_id" label="Schemanummer" /></v-col>
                    <v-col cols="12" sm="6">
                        <v-combobox v-model="label.rated_voltage" :items="presets.rated_voltage" label="Bemessungsspannung (Un)" />
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-combobox
                            v-model="label.rated_current"
                            label="Bemessungsstrom (InA)"
                            suffix="A"
                            hint="Mehrere Einspeisungen mit Enter trennen"
                            multiple
                            small-chips
                            deletable-chips
                            append-icon=""
                        />
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-combobox
                            v-model="label.frequency"
                            :items="presets.frequency"
                            label="Frequenz (fn)"
                            placeholder="automatisch: 50Hz, bei DC -"
                            persistent-placeholder
                            clearable
                        />
                    </v-col>
                    <v-col cols="12" sm="6"><v-combobox v-model="label.norm" :items="presets.norm" label="Normenabschnitt" /></v-col>
                </v-row>
                <div class="actions">
                    <v-btn text @click="preview">Vorschau</v-btn>
                    <v-btn color="primary" depressed @click="print">Drucken</v-btn>
                </div>
            </div>
        </div>
        <DocumentDialog ref="document_dialog" />
        <PrintDialog ref="print_dialog" />
    </Layout>
</template>

<style lang="scss" scoped>
.pruefkleber {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    padding: 1rem;
    overflow-y: auto;

    .pruefkleber-form {
        width: 100%;
        max-width: 700px;
        height: fit-content;
        padding: 1rem;
        background: white;
        box-shadow: $box-shadow-1;

        .layout-title {
            font-size: 20px;
            font-weight: bold;
            margin-bottom: 1rem;
        }

        .actions {
            display: flex;
            justify-content: flex-end;
            gap: 0.5rem;
            margin-top: 1rem;
        }
    }
}
</style>
